var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { MESSAGE_CHANNELS } from "@/types/messaging";
/** What became of the delivery report the fake posts for a message. */
export var EFakeReportState;
(function (EFakeReportState) {
    /** SMS (SNS) and email (SES): no report, as in production. */
    EFakeReportState["NO_RECEIPTS"] = "NO_RECEIPTS";
    /** Posted about a second after the message was accepted. */
    EFakeReportState["PENDING"] = "PENDING";
    /** The webhook component answered; `status` is its HTTP status. */
    EFakeReportState["ANSWERED"] = "ANSWERED";
    /** Not posted; `reason` says why. */
    EFakeReportState["NOT_SENT"] = "NOT_SENT";
    /** Posted, and the component didn't answer; `reason` says so. */
    EFakeReportState["UNREACHABLE"] = "UNREACHABLE";
})(EFakeReportState || (EFakeReportState = {}));
export var SENT_MESSAGES_MODES = __spreadArray(["ALL"], MESSAGE_CHANNELS, true);
/** The query parameter that keeps the mode; its presence also selects the tab. */
export var SENT_MESSAGES_PARAM = "channel";
/** How often the open tab reads the list again. */
export var SENT_MESSAGES_REFRESH_MS = 5000;
/** `?channel=` value of a mode (lower case, as typed in a link). */
export var modeParam = function (mode) { return mode.toLowerCase(); };
/** The mode a `?channel=` value names; anything else is All. */
export var parseMode = function (value) { var _a; return (_a = SENT_MESSAGES_MODES.find(function (mode) { return mode.toLowerCase() === (value === null || value === void 0 ? void 0 : value.trim().toLowerCase()); })) !== null && _a !== void 0 ? _a : "ALL"; };
